module.exports = __webpack_public_path__ + "img/MTNRadio.e63e9588.svg";